import type { PaywallCouponDuration } from "@circle-react/types/PaywallCoupon";
import { paywallCouponDurations } from "@circle-react/types/PaywallCoupon";
import { paywallCouponRedemptionStatuses } from "@circle-react/types/PaywallCouponRedemption";
import type {
  PaywallCouponRedemption,
  PaywallCouponRedemptionStatus,
} from "@circle-react/types/PaywallCouponRedemption";

const TYPE = Object.freeze({
  fixed: "PaywallCoupons::Fixed",
  percent: "PaywallCoupons::Percent",
});

export const isFixed = (type?: string) => type === TYPE.fixed;
export const isPercent = (type?: string) => type === TYPE.percent;
export const types = TYPE;

export const PAYWALL_COUPON_STATUS = Object.freeze({
  ACTIVE: "active",
  INACTIVE: "inactive",
});

export const PAYWALL_COUPON_STATUSES = [
  PAYWALL_COUPON_STATUS.ACTIVE,
  PAYWALL_COUPON_STATUS.INACTIVE,
];

export const isRedemptionRedeemed = (status: PaywallCouponRedemptionStatus) =>
  status !== paywallCouponRedemptionStatuses.incomplete;

export const isRedemptionEnded = (status: PaywallCouponRedemptionStatus) =>
  status === paywallCouponRedemptionStatuses.ended;

// Resolves the redeemed coupon code for a redemption, blank for a
// missing or incomplete (not-yet-redeemed) redemption.
export const getPaywallCouponCode = (
  redemption?: PaywallCouponRedemption,
): string => {
  if (!redemption || !isRedemptionRedeemed(redemption.status)) {
    return "";
  }
  return redemption.paywall_coupon?.code ?? "";
};

export const isRepeatingCoupon = (duration?: PaywallCouponDuration) =>
  duration === paywallCouponDurations.repeating;

export const isForeverCoupon = (duration?: PaywallCouponDuration) =>
  duration === paywallCouponDurations.forever;
